export default ({ debug, eventbus, store }) => {
  return new Promise((resolve) => {
    debug && console.log('bootstrap.gmap', 'init');

    store.dispatch('bootstrap/getConfig').then(config => {
      let apikey = config.google.map.key;
      
      let map = new GoogleMap({apikey, eventbus, store});
      eventbus.$on('gmap.load', map.load.bind(map));
      resolve();
      
      debug && console.log('bootstrap.gmap', 'completed');
    });
  })
}

class GoogleMap{
  constructor({apikey, eventbus, store}){
    this.apikey = apikey;
    this.eventbus = eventbus;
    this.store = store;
    this.id = 'google-maps-sdk';
    
    this.loaded = false;

    this.container = document.body;
  }

  load(){
    if (this.loaded){
      this.eventbus.$emit('googleMaps.loaded');
      return;
    }

    const js = document.createElement('script');
    js.id = this.id;
    js.onload = () => {
      this.loaded = true;
      this.store.dispatch('bootstrap/gmapLoaded', true);
      this.eventbus.$emit('gmap.loaded');
    };
    js.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${this.apikey}`;
    this.container.appendChild(js);
  }
}
